// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.alert {\r\n  fill: #f00;\r\n  color: #f00;\r\n  text-align: center;\r\n  max-width: 147px;\r\n  display: block;\r\n  margin: auto;\n}\n.dk {\r\n  max-width: 350px;\r\n  display: block;\r\n  margin: auto;\n}\r\n", ""]);
// Exports
module.exports = exports;
